import { QuestionSlideType, Slide } from '@llx/common';

import { SlideType } from '../enums';
import { QuestionTypes } from '../enums';

export function isSlideQuestionSlide(slide: Slide): slide is QuestionSlideType {
  return isTypeOfSlideQuestionType(slide.type);
}

function isTypeOfSlideQuestionType(type: SlideType): type is QuestionTypes {
  return (
    type === SlideType.QUESTION_SINGLE ||
    type === SlideType.QUESTION_MULTIPLE ||
    type === SlideType.QUESTION_MULTIPLE_ORDERED
  );
}
